<script>
import moment from 'moment';
import API from '../services/api';

const api = new API();

module.exports = {
  template: '#messages-template',
  computed: {
    id: function() {
      let id = typeof this.$route.params.id !== 'undefined' ? this.$route.params.id : false;

      if (!id) {
        return false;
      }

      dataLayer.push({
        event: 'GAEvent',
        eventCategory: 'OmaLaakkonen',
        eventAction: 'ReadMessages',
        eventLabel: '',
        eventNonInteraction: 'false'
      });

      api
        .setMessageRead({
          taskId: id
        })
        .then(res => {
          if (res.status == 1) {
            this.$store.state.messages = this.$store.state.messages.map(message => {
              if (message.taskId == id) message.isRead = true;

              return message;
            });
          }
        })
        .catch(error => {
          //console.log(error.statusText);
        });

      return id;
    },
    messages: function() {
      let messages = this.$store.state.messages ? this.$store.state.messages : [];

      messages = messages.map(message => {
        if (message.message !== null && typeof message.formatted == 'undefined') {
          message.message = message.message.replace(/((http|https):\/\/([A-Za-z0-1\.\/]+))/gi, function(i) {
            return '<a href="' + i + '">' + i + '</a>';
          });
          message.formatted = true;
        }

        return message;
      });

      return {
        count: messages.length,
        messages: messages,
        loading: messages ? false : true
      };
    }
  }
};
</script>